import { render, staticRenderFns } from "./formTemplate.vue?vue&type=template&id=3b16d037&"
import script from "./formTemplate.vue?vue&type=script&lang=js&"
export * from "./formTemplate.vue?vue&type=script&lang=js&"
import style0 from "./formTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports